import { HolderOutlined } from "@ant-design/icons"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Checkbox, Flex } from "antd"
import React from "react"

interface Props {
  id: string
  label: string
  visible: boolean
  onToggle: (next: boolean) => void
}

export const SortableColumnRow: React.FC<Props> = ({
  id,
  label,
  visible,
  onToggle
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    padding: 8,
    border: "1px solid #f0f0f0",
    borderRadius: 4,
    marginBottom: 4,
    background: "#fff"
  }

  return (
    <div ref={setNodeRef} style={style}>
      <Flex align="center" gap={8}>
        <span
          {...attributes}
          {...listeners}
          style={{ cursor: "grab", display: "inline-flex" }}
          aria-label="Drag to reorder"
        >
          <HolderOutlined />
        </span>
        <Checkbox
          checked={visible}
          onChange={(e) => onToggle(e.target.checked)}
        >
          {label}
        </Checkbox>
      </Flex>
    </div>
  )
}
